import { useState } from "react";
import { Button, Grid } from "@mui/material";
import Container from "../../components/Generics/Container";
import { Perfil } from "../../model/entities/Perfil";
import TextFieldGeneric from "../../components/Generics/TextFieldGeneric";
import PerfilField from "../../components/fields/PerfilField";
import { SaveOutlined } from "@mui/icons-material";
import { Plus } from "@phosphor-icons/react";
import CheckBoxGeneric from "../../components/Generics/CheckBoxGeneric";
import perfilApi from "../../api/perfilApi";

import { useSnack } from "../../redux/snack/snackHooks";
import { useSessao } from "../../redux/sessao/sessaoHooks";
import { useDispatch } from "react-redux";
import { loginAction } from "../../redux/sessao/sessaoActions";

type Props = {};

const PerfisPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const mostrarSnack = useSnack();
  const [sessao] = useSessao();
  const [perfilSelecionado, setPerfilSelecionado] = useState<Perfil | null>(
    null
  );

  const salvar = async () => {
    try {
      if (!perfilSelecionado) return;
      setLoading(true);
      if (!perfilSelecionado.id) {
        await perfilApi.insert(perfilSelecionado);
        mostrarSnack(
          `Novo perfil ${perfilSelecionado.descricao} cadastrado.`,
          "success"
        );
        setPerfilSelecionado(null);
        setLoading(false);
        return;
      }

      await perfilApi.update(perfilSelecionado.id, perfilSelecionado);

      if (sessao.usuario) {
        const action = loginAction({
          ...sessao,
          usuario: { ...sessao.usuario, perfil: perfilSelecionado },
        });
        dispatch(action);
      }
      mostrarSnack(
        `Perfil ${perfilSelecionado.descricao} atualizado.`,
        "success"
      );
      setPerfilSelecionado(null);
      setLoading(false);
    } catch (erro: any) {
      setLoading(false);
      mostrarSnack(
        `Errro ao atualizar informações do perfil ${perfilSelecionado?.descricao}`,
        "error"
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container page loading={loading}>
        <Grid container spacing={2}>
          {(!perfilSelecionado || !perfilSelecionado.id) && (
            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                children={"Novo perfil"}
                startIcon={<Plus />}
                onClick={() => setPerfilSelecionado({ ...new Perfil() })}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <PerfilField
              perfil={perfilSelecionado}
              setPerfil={(user) => {
                setPerfilSelecionado(user);
              }}
              idPerfil={perfilSelecionado?.id}
            />
          </Grid>

          {perfilSelecionado && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h2>Configurações do perfil {perfilSelecionado.descricao}</h2>
              </Grid>

              <Grid item xs={12}>
                <TextFieldGeneric
                  label="Descrição"
                  value={perfilSelecionado.descricao}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      descricao: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode cadastrar usuário"}
                  value={perfilSelecionado.podeCadastrarUsuario}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeCadastrarUsuario: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode cadastrar perfil"}
                  value={perfilSelecionado.podeCadastrarPerfil}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeCadastrarPerfil: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode cadastrar feriados"}
                  value={perfilSelecionado.podeCadastrarFeriado}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeCadastrarFeriado: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode editar agendamentos"}
                  value={perfilSelecionado.podeEditarAgendamento}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeEditarAgendamento: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode acessar solicitação de CTe"}
                  value={perfilSelecionado.podeAcessarSolicitacaoCte}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeAcessarSolicitacaoCte: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode acessar plano de manutenção"}
                  value={perfilSelecionado.podeAcessarPlanoManutencao}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeAcessarPlanoManutencao: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <CheckBoxGeneric
                  label={"Pode acessar solicitações pessoais"}
                  value={perfilSelecionado.podeAcessarSolicitacoesPessoais}
                  onChange={(value) => {
                    setPerfilSelecionado({
                      ...perfilSelecionado,
                      podeAcessarSolicitacoesPessoais: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Button
                  children={"Salvar"}
                  onClick={() => salvar()}
                  variant="contained"
                  startIcon={<SaveOutlined />}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default PerfisPage;
